import React from 'react';
import AccountsList from './accounts-list';

const AccountsTab = () => {
  return <AccountsList />;
};

export default AccountsTab;
